/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom';
import { getCookie } from '../../../utils/Cookies/CookieHandler';
import { getData } from '../../../utils/LocalStorage/LocalStorageManager';
import RenderTabs from '../../../components/ui/tabs/RenderTabs';

const HeaderTabs = () => {

  // Get current location using useLocation hook from react-router-dom
  const location = useLocation();
  const routePath = location.pathname;

  // Retrieve authentication cookie and user ID from the cookie
  const cookie = getCookie("AuthUser");
  const userID = cookie?.user?.lUserKey;


  const [navigationTabList, setNavigationTabList] = useState(null);

  // useEffect hook to update navigationTabList based on user ID and route path
  useEffect(() => {
    // Check if user is authenticated
    if (cookie.isAuthenticated) {
      // Retrieve navigation menu data from local storage
      const navigationTab = getData("NavigationMenu");

      // Find the current tab based on the route path
      const currentTab = navigationTab.find(item => item.sPage === routePath);

      // If current tab exists, filter navigation tabs based on its parent or child menu key
      if (currentTab) {
        let tabs;
        if (currentTab.lMenuKey === 1) {
          // Filter tabs for child menu
          tabs = navigationTab.filter(item => item.lMenuKey === currentTab.lChildMenuKey);
        } else {
          // Filter tabs for parent menu
          tabs = navigationTab.filter(item => item.lMenuKey === currentTab.lMenuKey);
        }
        // Set the filtered tabs to navigationTabList state
        setNavigationTabList(tabs);
      }
    }
  }, [userID, routePath]); // Dependencies for useEffect

  return (<RenderTabs tabs={navigationTabList} />

  )
}

export default HeaderTabs